import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const QAList = Loadable(lazy(() => import('./QAList')));
const AddQA = Loadable(lazy(() => import('./AddQA')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const QARoutes = [
  {
    path: '/QA/list',
    element: (
      //<PrivateRoute pageUrl="QAMaster" requiredFunc="VIE">
        <QAList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/QA/manage',
    element: (
      <PrivateRoute pageUrl="QAMaster" requiredFunc="ADD">
        <AddQA />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default QARoutes;
